import React, { useEffect, useState, useRef } from "react";
import classNames from "classnames";
import Inputtext from "../Inputtext";
import List, { ListItem, ListItemText } from "../List";
import { getOtherProperties, getParents } from "../common/Utils";
import { AutocompleteProps } from "./PropsType";

export default function Autocomplete(props: AutocompleteProps) {
  const {
    className,
    inline,
    maxHeight,
    prefixCls = "bm-Autocomplete",
    startAdorn,
    ...other
  }: any = props;
  const [state, setState] = useState({
    data: Array.isArray(props.data!) ? props.data : [],
    value: "",
    visible: false,
  });
  let selfClick = false;
  const { value, visible } = state;
  const styleClass = classNames(prefixCls, className);
  const menuClass = classNames(`${prefixCls}-menus`, {
    [`${prefixCls}-menus-active`]: visible!,
    [`${prefixCls}-inline`]: inline!,
    [`${prefixCls}-scroll`]: maxHeight,
  });
  const styles = {
    maxHeight,
  };
  const menuRef = useRef(null);
  const otherProps = getOtherProperties(other, [
    "data",
    "children",
    "onSelect",
  ]);

  const filterValue = (inputValue: string) => {
    let count = 0;
    const { count: countProps }: any = props;
    const { data }: any = state;
    return data.filter((value: any) => {
      const keep =
        (!inputValue ||
          value.label.toLowerCase().includes(inputValue.toLowerCase())) &&
        count <
          ((countProps && countProps !== -1) ||
            (countProps === -1 && data.length) ||
            5);

      if (keep) {
        count += 1;
      }
      return keep;
    });
  };

  // const handleDomClick = (event: any) => {
  //   if (state.visible) {
  //     clickOutside(
  //       event.target,
  //       prefixCls!,
  //       () => {
  //         selfClick = true;
  //         console.log(selfClick);
  //       },
  //       () => {
  //         selfClick = false;
  //         console.log(selfClick);
  //         setState({
  //           ...state,
  //           visible: false,
  //         });
  //       }
  //     );
  //   }
  // };

  const handleChange = (event) => {
    setState({
      ...state,
      value: event.value,
      visible: true,
    });
    if (props.onChange) {
      (props.onChange as (event: any) => void)({
        ...event,
      });
    }
  };

  const handleFocus = (event: any) => {
    if (props.onFocus) {
      (props.onFocus as (event: any) => void)({
        ...event,
      });
    }
  };

  const handleBlur = (event: any) => {
    if (props.onBlur) {
      (props.onBlur as (event: any) => void)({
        ...event,
      });
    }
  };

  const handleItemClick = (item: any, event: any) => {
    setState({
      ...state,
      value: item.label,
      visible: false,
    });
    if (props.onSelect) {
      (props.onSelect as (event: any) => void)({
        item,
        originalEvent: event,
      });
    }
  };

  const onDocumentListenerHandler = (event) => {
    if (!menuRef.current || !state.visible) {
      return;
    }
    const parents = getParents(event);
    if (parents.filter((parent) => parent === menuRef.current).length === 0) {
      setState({
        ...state,
        visible: false,
      });
    }
  };

  useEffect(() => {
    setState((prev) => {
      return {
        ...prev,
        data: Array.isArray(props.data!) ? props.data : [],
      };
    });
  }, [props?.data]);

  useEffect(() => {
    document.addEventListener("click", onDocumentListenerHandler);

    return () => {
      document.removeEventListener("click", onDocumentListenerHandler);
    };
  }, [onDocumentListenerHandler]);

  return (
    <div className={styleClass} {...otherProps} ref={menuRef}>
      <Inputtext
        value={value}
        startAdorn={startAdorn}
        onFocus={handleFocus}
        onBlur={handleBlur}
        onChange={handleChange}
      />
      <div className={menuClass} style={styles}>
        <List>
          {filterValue(value!).map((item: any, index: number) => {
            return (
              <ListItem
                key={"bm-Autocomplete-item-" + index}
                onClick={handleItemClick.bind(null, item)}
              >
                <ListItemText>{item.label}</ListItemText>
              </ListItem>
            );
          })}
        </List>
      </div>
    </div>
  );
}
